(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('MessagesPortalTemplateService', MessagesPortalTemplateService);

  MessagesPortalTemplateService.$inject = ['$resource'];

  function MessagesPortalTemplateService ($resource) {
    return $resource(apiUrl + '/messages-portal/:id', { id: '@id' }, {
      getAllDetailed: { url: apiUrl + '/messages-portal/templates/get-all-detailed', method: 'GET', params: {}, isArray: false },
      getChannelsSms: { url: apiUrl + '/messages-portal/templates/get-channels-sms', method: 'GET', params: {}, isArray: false },
      getChannelsWhatsapp: { url: apiUrl + '/messages-portal/templates/get-channels-whatsapp', method: 'GET', params: {}, isArray: false },
      getChannelsWaentSms: { url: apiUrl + '/messages-portal/templates/get-channels-waent-sms', method: 'GET', params: {}, isArray: false },
      getChannelsByChannelType: { url: apiUrl + '/messages-portal/templates/get-channels-by-type/:type', method: 'GET', params: {}, isArray: false },
      find: { url: apiUrl + '/messages-portal/templates/find', method: 'POST', params: {}, isArray: false },
      save: { url: apiUrl + '/messages-portal/templates/save', method: 'POST', params: {}, isArray: false },
      delete: { url: apiUrl + '/messages-portal/templates/delete', method: 'POST', params: {}, isArray: false }
    });
  }
})();
